import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const Panel = styled.div`
  position: fixed;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
  z-index: 1000;
  width: 220px;
  background: ${({ theme }) => theme.backgrounds.dashboardWidget};
  border: solid 1px ${({ theme }) => theme.borders.dashboard};
  box-shadow: 0 4px 24px 0 ${({ theme }) => theme.shadows.dashboard};
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const WidgetLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.dashboardTitle};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${({ theme }) => theme.text.dashboardTitle};
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionLabel = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${({ theme }) => theme.text.dashboardLightText};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const GrowOptions = styled.div`
  display: flex;
  gap: 6px;
`;

export const GrowButton = styled.button`
  flex: 1;
  height: 30px;
  border-radius: 4px;
  border: solid 1px ${({ theme, $active }) => $active ? theme.borders.workspaceSelectedItem : theme.borders.dashboard};
  background: ${({ theme, $active }) => $active ? theme.borders.workspaceSelectedItem : 'transparent'};
  color: ${({ theme, $active }) => $active ? '#fff' : theme.text.dashboardDarkText};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    border-color: ${({ theme }) => theme.borders.workspaceSelectedItem};
    color: ${({ theme, $active }) => $active ? '#fff' : theme.text.dashboardTitle};
  }
`;

export const RemoveButton = styled.button`
  width: 100%;
  height: 32px;
  border-radius: 4px;
  border: solid 1px #dc4a4a44;
  background: transparent;
  color: #dc4a4a;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: #dc4a4a22;
    border-color: #dc4a4a;
  }
`;
